import React, { Fragment } from "react";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function AutoComp(props) {
  const defaultProps = {
    options: props.options,
    getOptionLabel: (option) => option,
  };

  return (
    <Autocomplete
      clearOnBlur
      id={props.label}
      {...defaultProps}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {props.label === "Search for measure" ? <SearchIcon /> : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
      onChange={(event, value) => props.selection(value)}
    />
  );
}
